// import { useState } from "react";

// MUI
import { Grid, Typography, Divider, Box, Tooltip, ListItemProps } from "@mui/material";

// MUI icons
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";

// Project import
import IconButton from "components/@extended/IconButton";
import { useTranslation } from "utils/locales/utilityFunctions";
import NatureSection from "./natureSection";
import SpecialConditionsSection from "./specialConditionsSection";
import HarvestSection from "./harvestSection";
import { ActivityBiomassScreening } from "types/firestoreFeatures";

type NonForestBiomassFormProps = {
  biomassScreeningData: ActivityBiomassScreening;
  inputDisabled: boolean;
  files: ListItemProps[][];
  setBiomassScreeningData: ({
    value,
    key,
    parent,
  }: {
    value: any;
    key: string;
    parent?: string;
  }) => void;
  setOpenFilePickerModal: (state: boolean, categories?: string[]) => void;
};

const NonForestBiomassForm = ({
  biomassScreeningData,
  inputDisabled,
  files,
  setBiomassScreeningData,
  setOpenFilePickerModal,
}: NonForestBiomassFormProps) => {
  const { translate } = useTranslation();

  const loading = false;
  const error = false;

  const renderUploadButton = (mode: "dark" | "light", categories: string[]) => {
    return (
      <Tooltip title={translate("biomass-project-form-upload-doc-tooltip")}>
        <span>
          <IconButton
            variant={error ? "outlined" : "light"}
            color={error ? "error" : "secondary"}
            sx={{ bgcolor: mode === "dark" ? "secondary.light" : null }}
            onClick={() => setOpenFilePickerModal(true, ["screening", ...categories])}
            disabled={loading || inputDisabled}
          >
            <FileUploadRoundedIcon fontSize="small" color={loading || inputDisabled ? "disabled" : "primary"} />
          </IconButton>
        </span>
      </Tooltip>
    );
  };

  return (
    <>
      {/* ------------------- Species and harvest ------------------- */}
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: -1 }}>
          {translate("biomass-project-form-vegetation-and-intervention")}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Box sx={{ bgcolor: "secondary.lighter", p: 2, borderRadius: 1, mt: 1 }}>
          <HarvestSection
            biomassScreeningData={biomassScreeningData}
            inputDisabled={inputDisabled}
            setBiomassScreeningData={setBiomassScreeningData}
            renderUploadButton={renderUploadButton}
            onUploadRegenerationAgreement={setOpenFilePickerModal}
          />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ mt: 1 }} />
      </Grid>

      {/* ------------------- Nature ------------------- */}
      <NatureSection
        biomassScreeningData={biomassScreeningData}
        inputDisabled={inputDisabled}
        setBiomassScreeningData={setBiomassScreeningData}
        renderUploadButton={renderUploadButton}
        showNatureValues={true}
      />

      <Grid item xs={12}>
        <Divider sx={{ mt: 1 }} />
      </Grid>

      {/* ------------------- Special req. ------------------- */}
      <SpecialConditionsSection
        customerReq={biomassScreeningData?.customerRequirement || ""}
        inputDisabled={inputDisabled}
        setCustomerReq={(val) =>
          setBiomassScreeningData({ value: val, key: "customerRequirement" })
        }
      />

      {/* ------------------- Files ------------------- */}
      {/* {files.length > 0 && (
        <>
          <Grid item xs={12}>
            <Divider sx={{ mt: 1 }} />
          </Grid>
          <FilesSection files={files} />
        </>
      )} */}
    </>
  );
};

export default NonForestBiomassForm;
